import { api } from "..";

export interface ElevateSessionPayload {
  password: string;
}

export interface ElevateSessionResponse {
  elevated: boolean;
  expiresIn: number;
}

export async function elevateSession(
  payload: ElevateSessionPayload
): Promise<ElevateSessionResponse> {
  const res = await api.client.post("/auth-new/elevate", payload);
  return res.data;
}
